import { render, staticRenderFns } from "./addContainer.vue?vue&type=template&id=ef12a886&scoped=true&"
import script from "./addContainer.vue?vue&type=script&lang=js&"
export * from "./addContainer.vue?vue&type=script&lang=js&"
import style0 from "./addContainer.vue?vue&type=style&index=0&id=ef12a886&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef12a886",
  null
  
)

export default component.exports